import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { resolveHostedUrl } from 'src/app/constants/hosted-api-urls';
import { webSocket } from 'rxjs/webSocket';
import { Observable, timer, Subject, EMPTY } from 'rxjs';

import {
  retryWhen,
  tap,
  delayWhen,
  switchAll,
  catchError,
} from 'rxjs/operators';
export const WS_ENDPOINT = environment.wsSocketPrintEndpoint;
export const RECONNECT_INTERVAL = environment.wsReconnectInterval;

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  // socket: any;
  private get nestURL(): string {
    return resolveHostedUrl('nestURL');
  }
  private socketUrl = environment.wsSocketPrintEndpoint;
  private socket$;
  private isSocketOpened: boolean = false;
  private messagesSubject$ = new Subject();
  public messages$ = this.messagesSubject$.pipe(
    switchAll(),
    catchError((e) => {
      throw e;
    })
  );
  public reconnects = 0;

  constructor(private httpClient: HttpClient) {
    // this.socket = new WebSocket(this.socketUrl);
  }

  /**
   * Creates a new WebSocket subject and send it to the messages subject
   * @param cfg if true the observable will be retried.
   */
  public connect(cfg: { reconnect: boolean } = { reconnect: false }): void {
    this.reconnects++;
    if (!this.socket$ || this.socket$.closed) {
      this.socket$ = this.getNewWebSocket();
      const messages = this.socket$.pipe(
        cfg.reconnect ? this.reconnect : (o) => o,
        tap({
          error: (error) => console.log(error),
        }),
        catchError((_) => EMPTY)
      );
      this.socket$.subscribe();
      //TODO only next an observable if a new subscription was made double-check this
      this.messagesSubject$.next(messages);
    }
  }

  /**
   * Retry a given observable by a time span
   * @param observable the observable to be retried
   */
  private reconnect(observable: Observable<any>): Observable<any> {
    return observable.pipe(
      retryWhen((errors) =>
        errors.pipe(
          tap((val) =>
            console.log('[Socket Service] Try to reconnect...', val)
          ),
          delayWhen((_) => timer(RECONNECT_INTERVAL))
        )
      )
    );
  }

  /**
   * Return a custom WebSocket subject which reconnects after failure
   */
  private getNewWebSocket() {
    return webSocket({
      url: WS_ENDPOINT,
      openObserver: {
        next: () => {
          console.log('[Socket Service]: connection ok');
          this.isSocketOpened = true;
        },
      },
      closeObserver: {
        next: () => {
          console.log('[Socket Service]: connection closed');
          this.isSocketOpened = false;
          this.socket$ = undefined;
          if (this.reconnects < 10) {
            this.connect({ reconnect: true });
          } else {
            console.warn(
              'Maximum reconnects exceeded. Stopping connection Please reload Receiptprint application to initialized socket server'
            );
            this.reconnects = 0;
          }
        },
      },
    });
  }

  closeWebSocket() {
    this.socket$ && this.socket$.complete();
    this.socket$ = undefined;
  }

  sendMessage(msg: any) {
    this.socket$.next(msg);
  }

  get socketStatus() {
    return this.isSocketOpened;
  }

  offlineReceipt(data) {
    const url = `${this.nestURL}/api/receipt/receipt-data`;
    return this.httpClient.post<any>(url, data);
  }
  offlineReceiptCashDrawer(data) {
    const url = `${this.nestURL}/api/receipt/cash-mgt`;
    return this.httpClient.post<any>(url, data);
  }
  offlineDynamicQr(data){
    const url = `${this.nestURL}/api/receipt/generate-dynamic-qr`;
    return this.httpClient.post<any>(url, data);
  }
}
